// @workflow tasks.show-in-3d
/**
 * The words "show tasks in 3D" speaks, defined once: the modes, what the action answers, and why a
 * task was not shown. Shared by the action (actions/tasks.js), the board (Task/views/index.vue) and
 * the UI tool (Assistant/domain/taskTools.js).
 * No imports at all, so `npm run test:unit` (node --test) can load it directly.
 */

/** How the tasks are painted on the board's viewer. */
export const SHOW_TASKS_MODE = Object.freeze({
  /** Isolate the tasks' tags and keep the colouring the user chose on the board. */
  ISOLATE: 'isolate',
  /** Isolate them and colour them by task status (the task board charts' legend click). */
  STATUS: 'status',
});

/** What `showTasksInViewer` answers. */
export const SHOW_TASKS_STATUS = Object.freeze({
  /** The board's viewer panel opened on the tasks' tags. */
  SHOWN: 'shown',
  /** None of the tasks has a tag to show (the panel is left as it was). */
  NOTHING: 'nothing-to-show',
  /** No task board is on screen to show them on. */
  NO_BOARD: 'no-board',
  /** The user closed the facility picker. */
  CANCELLED: 'cancelled',
  /** The user picked another facility; it opened in a new tab. */
  OPENED_ELSEWHERE: 'opened-elsewhere',
});

/** Why a task that was asked for is not on screen (`skipped[].reason`). */
export const TASK_SKIP_REASON = Object.freeze({
  /** Not a task of this facility, or a task with no linked tag (direct, monitoring scope or anomaly component). */
  NO_TAGS: 'no_tags',
});

/** The board's viewer tabs (Dashboard/components/ViewersSection.vue `enabledTabs`). */
export const TASK_VIEWER_TAB = Object.freeze({
  MODEL_3D: '3D View',
  PLAN_2D: '2D View',
  PANORAMA: '360 View',
});
